module.exports = __webpack_public_path__ + "img/ligas-estatisticas.9aa1cab1.png";